import planningTranslationsHelper from "../../../../languages/planning-translations.helper";
import {
  CandidaturePreviewErrorType,
  CandidaturePreviewEntryCandidateCollisionError,
  CandidaturePreviewOrderInProgressError,
  CandidaturePreviewOrderNotExistsError,
  CandidaturePreviewTaxiDriverAssociationNotExistsError,
  CandidaturePreviewTaxiDriverContractNotValidError,
  CandidaturePreviewTaxiRailyContractNotExistsError,
} from "./candidature-preview-error";

const createPlanEntryCandidateCollisionError =
  (): CandidaturePreviewEntryCandidateCollisionError => {
    const translations =
      planningTranslationsHelper.getOrderTranslations().driverPlanListing
        .staging;

    return {
      message: translations.planEntryCandidateCollisionErrorLabel,
      params: {},
      type: CandidaturePreviewErrorType.PLAN_ENTRY_CANDIDATE_COLLISION,
    };
  };

const createTaxiDriverAssociationNotExistsError =
  (): CandidaturePreviewTaxiDriverAssociationNotExistsError => {
    const translations =
      planningTranslationsHelper.getOrderTranslations().driverPlanListing
        .staging;

    return {
      message: translations.taxiDriverAssociationNotExistsErrorLabel,
      params: {},
      type: CandidaturePreviewErrorType.TAXI_DRIVER_ASSOCIATION_NOT_EXISTS,
    };
  };

const createOrderNotExistsError = (): CandidaturePreviewOrderNotExistsError => {
  const translations =
    planningTranslationsHelper.getOrderTranslations().driverPlanListing.staging;

  return {
    message: translations.orderNotExistsErrorLabel,
    params: {},
    type: CandidaturePreviewErrorType.ORDER_NOT_EXISTS,
  };
};

const createOrderInProgressError =
  (): CandidaturePreviewOrderInProgressError => {
    const translations =
      planningTranslationsHelper.getOrderTranslations().driverPlanListing
        .staging;

    return {
      message: translations.orderInProgressErrorLabel,
      params: {},
      type: CandidaturePreviewErrorType.ORDER_IN_PROGRESS,
    };
  };

const createTaxiDriverContractNotValidError =
  (): CandidaturePreviewTaxiDriverContractNotValidError => {
    const translations =
      planningTranslationsHelper.getOrderTranslations().driverPlanListing
        .staging;

    return {
      message: translations.taxiDriverContractNotValidErrorLabel,
      params: {},
      type: CandidaturePreviewErrorType.TAXI_DRIVER_CONTRACT_NOT_VALID,
    };
  };

const createTaxiRailyContractNotValidError =
  (): CandidaturePreviewTaxiRailyContractNotExistsError => {
    const translations =
      planningTranslationsHelper.getOrderTranslations().driverPlanListing
        .staging;

    return {
      message: translations.taxiRailyContractNotValidErrorLabel,
      params: {},
      type: CandidaturePreviewErrorType.TAXI_RAILY_CONTRACT_NOT_VALID,
    };
  };

const candidaturePreviewErrorFactory = {
  createPlanEntryCandidateCollisionError,
  createTaxiDriverAssociationNotExistsError,
  createOrderNotExistsError,
  createOrderInProgressError,
  createTaxiDriverContractNotValidError,
  createTaxiRailyContractNotValidError,
};

export default candidaturePreviewErrorFactory;
